import { AxiosResponse } from 'axios';
import WbHttpClient from '../../../services/wbhttpclient';

export default class TeamServices extends WbHttpClient {
  public userFavorites(fav, params = {}): Promise<AxiosResponse> {
    return fav
      ? this.post('workboard/deleteUserFavorites', params)
      : this.post('workboard/addUserFavorites', params);
  }

  public archieveTeams(params = {}): Promise<AxiosResponse> {
    return this.post('team/archiveTeam', params);
  }
}
